import React, { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import CloseSharpIcon from "@mui/icons-material/CloseSharp";
import Topbar from "../../../components/Topbar/Topbar";
import {
  arrow_icon,
  delete_icon,
  dummyimage,
  edit_icon,
  Search_icon,
} from "../../../assets/img";
import HighlightOffRoundedIcon from "@mui/icons-material/HighlightOffRounded";
import { checkPermission } from "../../redux/api/PermissionManager";
import { useAsyncDebounce } from "react-table";
import { Table } from "../../../components/Table/Table";
import { useGlobalContext } from "../../../Services/PaginationGlobal";
import { get, patch, post } from "../../../Services/ApiHandler";
import { URLS } from "../../../Services/Constant";
import { toast } from "react-toastify";

const TYPE_MAP = {
  User: 43,
  "Reception Staff": 45,
};

const CHAR_LIMIT = 100;

const RoomSOS = () => {
  const { paginationData, setpaginationData } = useGlobalContext();
  const { pathname } = useLocation();
  const path = pathname?.replace("/", "");

  const navigate = useNavigate();
  const [pageByTab, setPageByTab] = useState({
    User: paginationData?.[path]?.page?.User ?? 1,
    "Reception Staff": paginationData?.[path]?.page?.["Reception Staff"] ?? 1,
  });
  const [pagination, setPagination] = useState({});
  const [count, setCount] = useState(0);
  const [active, setActive] = useState("User");
  const activeRef = useRef(active);
  useEffect(() => {
    activeRef.current = active;
  }, [active]);

  const page = pageByTab[active];
  const setPage = (value) => {
    const currentTab = activeRef.current;
    setPageByTab((prev) => ({
      ...prev,
      [currentTab]:
        typeof value === "function" ? value(prev[currentTab]) : value,
    }));
  };
  const [selectedFilter, setSelectedFilter] = useState({
    search: paginationData?.[path]?.search ?? "",
  });
  const [list, setList] = useState([]);
  const [addPopup, setAddPopup] = useState(false);
  const [tip, setTip] = useState("");
  const [names, setNames] = useState([]);
  const [deletePopup, setDeletePopup] = useState(false);

  const handleChangeFilter = (name, val) => {
    setPage(1);
    setSelectedFilter((prev) => ({ ...prev, [name]: val }));
  };

  useEffect(() => {
    getList(page, active);
    setpaginationData((prev) => ({
      ...prev,
      [path]: { page: pageByTab, search: selectedFilter.search },
    }));
  }, [page, selectedFilter, active]);

  const getList = async (pageNumber = 1, tab = activeRef.current) => {
    let res = await get(
      `${URLS.MASTERURL}?type=${TYPE_MAP[tab]}&page=${pageNumber}&search=${
        selectedFilter.search
      }`,
    );
    if (res?.status === "success") {
      if (tab !== activeRef.current) return;
      setCount(res?.count);
      setPagination({
        current_page: pageNumber,
        last_page: res?.total_pages,
      });
      setList(res?.data ?? []);
    }
  };

  const handleStatus = async ({ id, status }) => {
    const tabAtClick = activeRef.current;
    const pageAtClick = pageByTab[tabAtClick];
    const formdata = new FormData();
    formdata.append("status", !status);
    const res = await post(`${URLS.MASTERURL}${id}/status/`, formdata);
    if (res?.status === "success") {
      toast.success(res?.message || "Status updated");
      getList(pageAtClick, tabAtClick);
    }
  };

  const handleDelete = async (id) => {
    const tabAtClick = activeRef.current;
    const pageAtClick = pageByTab[tabAtClick];
    const res = await post(`${URLS.MASTERURL}${id}/delete/`);
    if (res?.status === "success") {
      toast.success(res?.message);
      getList(pageAtClick, tabAtClick);
      setDeletePopup(false);
    }
  };

  const submit = async () => {
    let edit = typeof addPopup === "object";
    if (!tip.trim() && names.length === 0) {
      toast.error("Please enter Questionnaire");
      return;
    }
    if (edit && tip.trim().length > CHAR_LIMIT) {
      toast.error(`Limit is ${CHAR_LIMIT} characters`);
      return;
    }
    const tabAtClick = activeRef.current;
    const pageAtClick = pageByTab[tabAtClick];
    const formdata = new FormData();
    formdata.append("type", TYPE_MAP[tabAtClick]);
    formdata.append("name", edit ? tip : names);
    if (!edit) formdata.append("status", true);
    let url = edit
      ? `${URLS.MASTERURL}${addPopup?.id}/edit/`
      : `${URLS.MASTERURL}add/`;
    const res = await post(url, formdata);
    if (res?.status === "success") {
      toast.success("Edited successfully");
      getList(pageAtClick, tabAtClick);
      setNames([]);
      setTip("");
      setAddPopup(false);
    }
  };

  const columns = React.useMemo(() => {
    let d = [
      {
        Header: "S.No",
        accessor: "",
        Cell: ({ value, row }) => {
          return <p className="red"> {(page - 1) * 10 + (row.index + 1)}</p>;
        },
      },
      {
        Header: "SOS Questionnaire",
        accessor: "name",
        Cell: ({ value, row }) => {
          return <p>{value}</p>;
        },
      },
      {
        Header: "Status",
        accessor: "status",
        Cell: ({ value, row }) => {
          return (
            <div>
              <button
                onClick={() => {
                  if (checkPermission("CAN-STATUS-CHECK_IN"))
                    handleStatus(row.original);
                }}
                className={`${
                  value ? "active-btn" : "deactive-btn"
                } border-0 ms-2`}
                style={{ fontSize: "12px" }}
              >
                {value ? " Active" : "De-active"}
              </button>
            </div>
          );
        },
      },
    ];
    let action = {
      Header: "Action",
      accessor: "id",
      Cell: ({ value, row }) => (
        <div className="d-flex ac-js">
          {checkPermission("CAN-EDIT-CHECK_IN") && (
            <button
              onClick={() => {
                setAddPopup(row.original);
                setTip(row.original.name);
              }}
              className="cust-btn"
            >
              <img src={edit_icon} alt="" className="mx-2 edit-btn" />
            </button>
          )}
          {checkPermission("CAN-DELETE-CHECK_IN") && (
            <button
              onClick={() => {
                setDeletePopup(value);
              }}
              className="cust-btn"
            >
              <img src={delete_icon} alt="" className="mx-2 edit-btn" />
            </button>
          )}
        </div>
      ),
    };
    return checkPermission("CAN-EDIT-CHECK_IN") ||
      checkPermission("CAN-DELETE-CHECK_IN")
      ? [...d, action]
      : d;
  }, [page]);

  return (
    <div>
      <Topbar header={"Room SOS"} />
      <div className="d-flex ac-jb">
        <div className="d-flex gap-3">
          {["User", "Reception Staff"].map((ele) => {
            return (
              <div
                key={ele}
                style={{
                  background: active == ele ? "#AE55F5" : "#78788029",
                  padding: "10px 30px",
                  borderRadius: 7,
                  cursor: "pointer",
                }}
                onClick={() => {
                  setActive(ele);
                }}
              >
                <p style={{ color: active == ele ? "#fff" : "#000" }}>{ele}</p>
              </div>
            );
          })}
        </div>

        <div className="d-flex ac-js gap-3">
          <button
            className="f2 fs-sm-10 fs-md-12 fs-lg-13 fs-xl-14 fs-xxl-16 white push-btn "
            onClick={() => setAddPopup(true)}
          >
            {" "}
            + Add Questionnaire
          </button>
        </div>
      </div>
      {(active === "User" || active === "Reception Staff") && (
        <Table
          columns={columns}
          setPageno={setPage}
          pagecount={pagination}
          data={list}
          show={true}
        />
      )}
      {addPopup && (
        <div className="img-popup-design">
          <div className="img-popup">
            <div className="d-flex ac-jb">
              <p className="f4 text-start  fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 ">
                {typeof addPopup === "object" ? "Edit" : "Add"}
              </p>
              <CloseSharpIcon
                onClick={() => {
                  setAddPopup(false);
                  setTip("");
                  setNames([]);
                }}
                className="pointer"
              />
            </div>
            <div className="d-flex ac-js mt-3">
              <div className="w-100">
                <div className="d-flex ac-jb mb-3">
                  <p className="f3 fs-sm-12 fs-md-16 fs-lg-18 fs-xl-20 fs-xxl-22 ">
                    SOS Questionnaire{" "}
                  </p>
                </div>
                {typeof addPopup !== "object" && (
                  <div>
                    <div>
                      <div className="d-flex ae-jb input-border p-1">
                        <div className="w-80 d-flex flex-column">
                          <textarea
                            style={{ maxHeight: "80px" }}
                            maxLength={CHAR_LIMIT}
                            value={tip}
                            onChange={(e) => {
                              const val = e.target.value;
                              if (val.length <= CHAR_LIMIT) {
                                setTip(val);
                              }
                            }}
                            placeholder="Write Here...."
                            className="border-0 mb-1 w-100"
                          />
                          <span
                            className="f2 fs-sm-9 fs-md-10"
                            style={{
                              color: tip.length >= CHAR_LIMIT ? "red" : "#888",
                              alignSelf: "flex-end",
                            }}
                          >
                            {tip.length}/{CHAR_LIMIT}
                          </span>
                        </div>
                        <button
                          onClick={() => {
                            if (!tip.trim()) {
                              toast.error("Please enter Questionnaire");
                              return;
                            }
                            if (tip.trim().length > CHAR_LIMIT) {
                              toast.error(`Limit is ${CHAR_LIMIT} characters`);
                              return;
                            }
                            setNames((prev) => [
                              ...prev.filter((i) => i !== tip),
                              tip,
                            ]);
                            setTip("");
                          }}
                          className="submit-btn f2 fs-sm-10 fs-md-10 fs-lg-10 fs-xl-12 fs-xxl-14 p-1"
                          style={{ minWidth: "100px" }}
                        >
                          Add
                        </button>
                      </div>
                    </div>
                    <div>
                      {names.length > 0 ? (
                        <ul
                          className="input-border overflow-scroll mt-2"
                          style={{ minHeight: "50px", maxHeight: "200px" }}
                        >
                          {names?.map((name, index) => {
                            return (
                              <li
                                className="d-flex as-js gap-3 mt-2"
                                key={index}
                              >
                                <img
                                  src={arrow_icon}
                                  className="bullet-btn"
                                  alt=""
                                />
                                <p className="f2 fs-sm-10 fs-md-14 fs-lg-15 fs-xl-14 fs-xxl-16 w-80 text-start">
                                  {name}
                                </p>
                                <img
                                  src={delete_icon}
                                  className="delete-btn"
                                  onClick={() => {
                                    setNames((prev) =>
                                      prev.filter((i) => i !== name),
                                    );
                                  }}
                                />
                              </li>
                            );
                          })}
                        </ul>
                      ) : (
                        ""
                      )}
                    </div>
                  </div>
                )}
                {typeof addPopup === "object" && (
                  <div className="d-flex flex-column">
                    <textarea
                      style={{ maxHeight: "80px" }}
                      maxLength={CHAR_LIMIT}
                      value={tip}
                      onChange={(e) => {
                        const val = e.target.value;
                        if (val.length <= CHAR_LIMIT) {
                          setTip(val);
                        }
                      }}
                      placeholder="Write Here.... "
                      className="input-box"
                    />
                    <span
                      className="f2 fs-sm-9 fs-md-10"
                      style={{
                        color: tip.length >= CHAR_LIMIT ? "red" : "#888",
                        alignSelf: "flex-end",
                      }}
                    >
                      {tip.length}/{CHAR_LIMIT}
                    </span>
                  </div>
                )}
              </div>
            </div>
            <div className="d-flex ac-je px-2 mt-4">
              <button
                onClick={() => {
                  submit();
                }}
                className="submit-btn f2 w-40 p-2 fs-sm-11 fs-md-12 fs-lg-13 fs-xl-14 fs-xxl-15"
              >
                {" "}
                Submit
              </button>
            </div>
          </div>
        </div>
      )}
      {deletePopup && (
        <div className="img-popup-design">
          <div className="img-popup">
            <p className="f3 ms-2  ms-md-2 ms-lg-2 ms-xl-2 fs-xs-10 fs-sm-11 fs-md-12 fs-lg-13 fs-xl-14 fs-xxl-15 mt-4">
              Are you sure, want to Delete?
            </p>
            <div className="d-flex ac-jb px-2 mt-5">
              <button
                onClick={() => handleDelete(deletePopup)}
                className="add-btn w-40"
              >
                Yes
              </button>
              <button
                onClick={() => {
                  setDeletePopup(false);
                }}
                className="back-btn f2 w-40"
              >
                No
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default RoomSOS;
